import { useQuery } from 'react-query';
import { network } from 'services/network';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { QueryKeys } from 'api/queryKeys';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { SelectByOptionsValue } from 'components/widgets/RiskDensity/RiskDensity.utils';

const getHeatMapActivityStartOrFinish = (params: Omit<QueryParams, 'selectBy'>) => {
    return network.post<QueryFnResponse>('api/bo/getHeatMapActivityStartOrFinish', params).then((response) => {
        return response.data;
    });
};

const getHeatMapActivityDuration = (params: Omit<QueryParams, 'selectBy'>) => {
    return network.post<QueryFnResponse>('api/bo/getHeatMapActivityDuration', params).then((response) => {
        return response.data;
    });
};

const getHeatMapActivityStart = (params: Omit<QueryParams, 'selectBy'>) => {
    return network.post<QueryFnResponse>('api/bo/getHeatMapActivityStart', params).then((response) => {
        return response.data;
    });
};

const getHeatMapResources = (params: Omit<QueryParams, 'selectBy'>) => {
    return network.post<QueryFnResponse>('api/bo/getHeatMapResources', params).then((response) => {
        return response.data;
    });
};

export const useQueryRiskDensityBy = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['riskDensityBy', params],
        queryFn: () => {
            let queryFn: (params: Omit<QueryParams, 'selectBy'>) => Promise<QueryFnResponse>;
            switch (params.selectBy) {
                case 'heatMapActivityStartOrFinish':
                    queryFn = getHeatMapActivityStartOrFinish;
                    break;
                case 'heatMapActivityDuration':
                    queryFn = getHeatMapActivityDuration;
                    break;
                case 'heatMapActivityStarts':
                    queryFn = getHeatMapActivityStart;
                    break;
                case 'heatMapActivityResources':
                    queryFn = getHeatMapResources;
                    break;
            }
            //eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { selectBy, ...rest } = params; //delete selectBy property
            return queryFn(rest);
        },
        enabled: params.id.length > 0 && Boolean(params.selectBy),
    });
};

interface QueryParams extends NarrativeRequest {
    id: number[];
    filter: {
        filters: IFilter[];
    };
    startDate: number | null;
    endDate: number | null;
    isWeekResolution: boolean;
    selectBy: SelectByOptionsValue;
}

export interface IHeatMapData {
    endDate: number;
    numOfDelayDrivers: number;
    numOfTasksPerMonth: number;
    percentile: number;
    score: number;
    startDate: number;
}

interface QueryFnResponse {
    info?: IToolTip;
    startProjectDate: number;
    endProjectDate: number;
    heatMapItemResponseList: IHeatMapData[];
}

export type QueryResponse = QueryFnResponse;
